import { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from '@core/errors/api-error';

export class ForbiddenApiError extends ApiError {
  constructor(cause: HttpErrorResponse, body: unknown) {
    super('ForbiddenApiError', cause, body);
  }
}
